import { useState } from "react"
import Axios from "axios"
import Swal from "sweetalert2"
import { useNavigate } from "react-router-dom"
import { Modal } from "react-bootstrap"

import { OPTION_INFO, getEAPOptions, getBorderCityOptions } from "./utils.js"
import { useAuth } from "../../context/auth-context"
import { useGeneralStates } from "../../context/general-context.jsx"
import DropdownOption from "./dropdownOption.jsx"
import MapboxInput from "./mapboxInput.jsx"
import { ACTIONS, APP_ROUTES, sweetAlertLoading } from "../../utils/globalUtils.js"


export default function InputsSection() {
    const { user, updateUser } = useAuth()
    const { state, dispatch } = useGeneralStates()
    const navigate = useNavigate()

    const [currentInput, setCurrentInput] = useState("population")
    const [showInfo, setShowInfo] = useState({
        icon: OPTION_INFO[0]?.image,
        title: OPTION_INFO[0]?.title,
        description: OPTION_INFO[0]?.description,
        show: false,
    })

    function handleOptions(value, property) {
        const userToSave = {
            ...user,
            inputsData: {
                ...user?.inputsData,
                [property]: value,
            }
        }

        if (property === "population") {
            userToSave.inputsData.eap = null
        }

        if (property === "eap") {
            userToSave.inputsData.borderCity = null
        }

        Axios.patch(`${process.env.REACT_APP_TEASER_USER}${user._id}`, { user: userToSave }).then(res => {
            updateUser(res.data)
        }).catch(err => {
            Swal.fire({
                icon: "error",
                title: err?.response?.data?.message || "Error updating report information",
                showConfirmButton: false,
                showCancelButton: false,
                timer: 2500,
                timerProgressBar: true,
            });
            console.log(err?.response?.data?.message || "Error updating report information")
        })
    }

    function handleCurrentInput(current) {
        setCurrentInput(current)
    }

    function handleResults() {
        if (!allInputs) return

        Swal.fire({
            icon: "question",
            text: "Are you sure you want to proceed with this selection?​ You only have one attempt.",
            footer: "Only have one try..",
            showConfirmButton: true,
            confirmButtonText: "Generate Report",
            showCancelButton: true,
            cancelButtonText: "Change Selection",
            customClass: {
                confirmButton: "swal2-button--confirm",
                cancelButton: "swal2-button--cancel",
                footer: "swal2-footer-section"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                sweetAlertLoading()
                Axios.get(`${process.env.REACT_APP_CALCULATE_RESULTS}${user._id}`).then(res => {
                    updateUser(res.data?.user)

                    const {
                        clientLocation,
                        supplierLocation
                    } = res.data
                    
                    dispatch({ type: ACTIONS.setClientAndSupplierLocation, payload: { clientLocation, supplierLocation } })
                    // console.log(res.data)
                    Swal.close()
                    dispatch({ type: ACTIONS.setShowColumn, payload: "show" })
                    setTimeout(() => navigate(APP_ROUTES.results), 800)
                }).catch(err => {
                    console.log(err?.response?.data?.message || "Error getting results")
                    Swal.fire({
                        icon: "error",
                        title: err?.response?.data?.message || "Error getting results",
                        showConfirmButton: false,
                        showCancelButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                    });
                })
            }
        })
    }

    function handleShowInfo(id) {
        if (!id) {
            setShowInfo(prev => {
                return {
                    ...prev,
                    show: false
                }
            })

            return
        }


        const option = OPTION_INFO.find(opt => opt.accessKey === id)
        const modalImageToShow = option?.image
        const modalTitleToShow = option?.title
        const modalDescriptionToShow = option?.description

        setShowInfo({
            icon: modalImageToShow,
            title: modalTitleToShow,
            description: modalDescriptionToShow,
            show: true
        })
    }

    const currentInputObject = OPTION_INFO.find(opt => opt.accessKey === currentInput) 
    const imageToShow = currentInputObject?.image
    const titleToShow = currentInputObject?.title
    const descriptionToShow = currentInputObject?.description

    const userInputs = user?.inputsData
    const allInputs = OPTION_INFO.every(option => userInputs?.[option.accessKey])

    return (
        <>
            <div className="infoSection">
                <div className="optionsSection">
                    {OPTION_INFO.map(item => {
                        if (item.accessKey === "headquarters") {
                            return (
                                <MapboxInput
                                    key={item.id}
                                    option={item}
                                    optionValue={user?.inputsData?.[item.accessKey]}
                                    handleCurrentInput={handleCurrentInput}
                                    handleOptions={handleOptions}
                                    handleShowInfo={handleShowInfo}
                                />
                            )
                        }
                        
                        
                        
                        const isDisabled = item.accessKey === "eap" || item.accessKey === "borderCity"
                        const items = item.accessKey !== "eap" && item.accessKey !== "borderCity" ?
                            item.options :

                            (item.accessKey === "eap" ?
                                item.options.filter(opt => getEAPOptions(user?.inputsData?.population, opt, state.teaserCities))
                                :
                                item.options.filter(opt => getBorderCityOptions(user?.inputsData?.population, user?.inputsData?.eap, opt, state.teaserCities))
                            )

                        return (
                            <DropdownOption
                                key={item.id}
                                option={item}
                                items={items}
                                optionValue={user?.inputsData?.[item.accessKey]}
                                optionDisabled={isDisabled}
                                showInfo={showInfo}
                                handleCurrentInput={handleCurrentInput}
                                handleOptions={handleOptions}
                                handleShowInfo={handleShowInfo}
                            />
                        )
                    })}
                </div>

                <aside className="optionInfo d-none d-lg-block">
                    <img src={imageToShow} alt="Prodensa Teaser" />
                    <h4 className="optionTitle">{titleToShow}</h4>
                    <span>
                        {descriptionToShow}
                    </span>
                </aside>
            </div>

            <div className="actionsContainer">
                <button className="cancelButton">Cancel</button>
                <button
                    className="btnBgBlueTextGradient"
                    disabled={!allInputs}
                    onClick={handleResults}
                >
                    Submit
                </button>
            </div>

            <Modal
                className="mobile-option-info-modal"
                size="md"
                centered
                show={showInfo?.show}
                onHide={() => handleShowInfo(null)}
            >
                <Modal.Body>
                    <img src={showInfo?.icon} alt="Prodensa Teaser" />
                    <h4 className="optionTitle">{showInfo?.title}</h4>
                    <span>
                        {showInfo?.description}
                    </span>
                </Modal.Body>
            </Modal>
        </>
    )
}
